import React from 'react';

import classnames from 'classnames';

import { useSelectValueNode } from './useSelectValueNode';

import styles from './SelectValue.module.scss';

type SelectValueProps = {
    className?: string;
};

export const SelectValue = ({ className }: SelectValueProps) => {
    const valueNode = useSelectValueNode();

    if (!valueNode) return null;

    return <div className={classnames(styles.container, className)}>{valueNode}</div>;
};
